import styled from "styled-components";

export const Container = styled.div`
	max-width: 560px;
	margin: 0 auto;
`;
